/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - Category Management
=========================================================
*/

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useProduct from "hooks/useProduct";

export default function data() {
  const navigate = useNavigate();
  const { getProductList, deleteProduct, productList } = useProduct();
  // Dummy product data following the structure you provided
  const [data, setData] = useState([]);

  const handleDeleteDealer = async (productId) => {
    if (window.confirm("Are you sure you want to delete this product?")) {
      // setLoading((prev) => ({ ...prev, [productId]: { ...prev[productId], delete: true } }));
      try {
        const res = await deleteProduct(productId);
        if (res.success) {
          alert("Product deleted successfully!");
          fetchList();
        }
      } catch (err) {
        console.error("Error deleting product:", err);
        alert("An error occurred while deleting the product.");
      } finally {
        // setLoading((prev) => ({ ...prev, [productId]: { ...prev[productId], delete: false } }));
      }
    }
  };

  const ProductActions = ({ onEdit, onDelete }) => (
    <MDBox display="flex" justifyContent="center">
      <MDButton variant="contained" color="info" onClick={onEdit} sx={{ mr: 1 }}>
        <EditIcon />
      </MDButton>
      <MDButton variant="contained" color="error" onClick={onDelete} sx={{ mr: 1 }}>
        <DeleteIcon />
      </MDButton>
    </MDBox>
  );

  const ProductInfo = ({ name, amount, marketPrice }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
        <MDTypography variant="caption" color="text" display="block">
          Amount: ₹{amount} | Market Price: ₹{marketPrice}
        </MDTypography>
      </MDBox>
    </MDBox>
  );

  const rows = data?.map((product) => ({
    product: (
      <ProductInfo name={product.name} amount={product.amount} marketPrice={product.marketPrice} />
    ),
    category: product.category.name,
    amount: `₹ ${product.amount}`,
    marketPrice: `₹ ${product.marketPrice}`,
    actions: (
      <ProductActions
        onEdit={() => navigate(`/product-management/edit?id=${product._id}`)}
        onDelete={() => handleDeleteDealer(product._id)}
      />
    ),
  }));

  const fetchList = async () => {
    await getProductList();
  };
  useEffect(() => {
    if (productList.products) {
      setData(productList?.products || []);
    }
  }, [productList]);

  return {
    columns: [
      { Header: "Product", accessor: "product", width: "30%", align: "left" },
      { Header: "Category", accessor: "category", align: "left" },
      { Header: "Amount", accessor: "amount", align: "left" },
      { Header: "Market Price", accessor: "marketPrice", align: "left" },
      { Header: "Actions", accessor: "actions", align: "center" },
    ],
    rows,
  };
}
